module.exports = __webpack_public_path__ + "static/eindruecke4-449931bcde4254b5ac679c7cf2e1807d.jpg";